import { useLayoutEffect, useState } from 'react';

import { GAP, MENU_MAX_HEIGHT, VIEWPORT_PADDING } from '../constants';

function useGroupedDropdownMenuPosition(wrapperRef, dropdownOpen, usePortal, isTopProp) {
  const [menuPosition, setMenuPosition] = useState(null);

  useLayoutEffect(() => {
    if (!usePortal || !dropdownOpen || !wrapperRef.current) {
      setMenuPosition(null);
      return;
    }

    const rect = wrapperRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom - VIEWPORT_PADDING;
    const spaceAbove = rect.top - VIEWPORT_PADDING;
    const openAbove =
      isTopProp !== undefined && isTopProp !== null
        ? isTopProp
        : spaceBelow < MENU_MAX_HEIGHT && spaceAbove >= VIEWPORT_PADDING;

    let left = rect.left;
    const width = Math.min(rect.width, window.innerWidth - 2 * VIEWPORT_PADDING);
    if (left + width > window.innerWidth - VIEWPORT_PADDING) {
      left = window.innerWidth - width - VIEWPORT_PADDING;
    }
    if (left < VIEWPORT_PADDING) {
      left = VIEWPORT_PADDING;
    }

    setMenuPosition({
      top: openAbove ? undefined : rect.bottom + GAP,
      bottom: openAbove ? window.innerHeight - rect.top + GAP : undefined,
      left,
      width,
    });
  }, [usePortal, dropdownOpen, isTopProp, wrapperRef]);

  return menuPosition;
}

export default useGroupedDropdownMenuPosition;
